<template>
  <div class="about-max" style="overflow: hidden">
    <div class="about-max-box">
      <div class="about-max-introduce">
        <div class="about-max-introduce-headline">中航运捷运</div>
        <div class="about-max-introduce-content">
          <div>中航运捷运物流（上海）有限公司是全球捷运物流集团设立的数字化物流运营平台。专注于智能化的供应链管理，凭借先进的智慧物流理念，与智慧仓储、数字港口一起构成了互联网+形态下数字化的智慧物流生态圈。</div>
          <div
            style="margin-top:20px;"
          >建立现代化的全程物流高效运营平台，实现客户，承运人及各方代理之间信息便利和利益共享是中航运捷运物流孜孜不倦的追求。公司依托中国本土及海外建立的服务网络、结合从工厂到消费者全程覆盖的供应链大数据平台，以及线上线下相结合的智能分析技术，致力于打造从产品研发推广，到线下车队、仓库、报关、堆场、码头等各节点的高效互动，实现信息可视化，时效合理化，利益最大化的多赢目标。</div>
          <div
            style="margin-top:20px;"
          >秉承科技创新、效率至上的服务理念，依托数字化及智能化的管理平台，中航运捷运物流将为广大客户提供优质高效的智能化物流服务，共同提升供应链运营效率。</div>
        </div>
      </div>
      <div class="about-max-photos">
        <img src="../assets/img/bj2.png" alt />
      </div>
    </div>
    <div class="map-max-box">
      <div class="map-max-introduce">
        <div class="map-max-introduce-headline">{{this.mapHeadline}}</div>
        <div class="map-max-introduce-content">{{this.mapText}}</div>
        <div class="map-max-introduce-content2">{{this.mapText2}}</div>
        <div class="map-max-introduce-content">{{this.mapText3}}</div>
        <div class="map-max-introduce-content">{{this.mapText4}}</div>
        <div class="map-max-introduce-content2">{{this.mapText5}}</div>
        <div class="map-max-introduce-principal">主营业务</div>
        <div style=" width: 500px;">
          <div
            v-if="this.partnerList.pic1 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic9.png" alt />
            <div class="map-max-introduce-text">海运</div>
          </div>
          <div
            v-if="this.partnerList.pic2 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic10.png" alt />
            <div class="map-max-introduce-text">空运</div>
          </div>
          <div
            v-if="this.partnerList.pic3 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic3.png" alt />
            <div class="map-max-introduce-text">卡车运输</div>
          </div>
          <div
            v-if="this.partnerList.pic4 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic5.png" alt />
            <div class="map-max-introduce-text">报关</div>
          </div>
          <div
            v-if="this.partnerList.pic5 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic8.png" alt />
            <div class="map-max-introduce-text">无船承运人</div>
          </div>
          <div
            v-if="this.partnerList.pic6 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic1.png" alt />
            <div class="map-max-introduce-text">多式联运</div>
          </div>
          <div
            v-if="this.partnerList.pic7 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic6.png" alt />
            <div class="map-max-introduce-text">进口</div>
          </div>
          <div
            v-if="this.partnerList.pic8 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic7.png" alt />
            <div class="map-max-introduce-text">合同物流</div>
          </div>
          <div
            v-if="this.partnerList.pic9 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic2.png" alt />
            <div class="map-max-introduce-text">集拼</div>
          </div>

          <div
            v-if="this.partnerList.pic10 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic4.png" alt />
            <div class="map-max-introduce-text">堆场</div>
          </div>

          <div
            v-if="this.partnerList.pic11 ==1"
            style="display: inline-block;width: 18%;padding-top: 10px;"
          >
            <img src="../assets/img/pic11.png" alt />
            <div class="map-max-introduce-text">集装箱货物集散站 / 仓储</div>
          </div>
        </div>
      </div>
      <div class="map-max-photos">
        <div class="map-dot" @click="coord(1)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">上海</div>
        </div>
        <div class="map-dot map-dot2" @click="coord(2)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">大连</div>
        </div>
        <div class="map-dot map-dot3" @click="coord(3)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">天津</div>
        </div>
        <div class="map-dot map-dot4" @click="coord(4)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">青岛</div>
        </div>
        <div class="map-dot map-dot5" @click="coord(5)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">宁波</div>
        </div>
        <div class="map-dot map-dot6" @click="coord(6)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">厦门</div>
        </div>
        <div class="map-dot map-dot7" @click="coord(7)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">广州</div>
        </div>
        <div class="map-dot map-dot8" @click="coord(8)">
          <div class="map-dot-picture"></div>
          <div class="map-dot-text">深圳</div>
        </div>
      </div>
      <img class="map-box" :src="homeUrl.homeImage" alt />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mapHeadline: "中航运上海",
      mapText:
        "中航运上海是中国区总公司，于2020年3月成立，公司以海、空货运代理业务为主，集海上运输、航空运输、海铁联运、国际多式联运、合同物流、仓储服务等为一体的大型现代化综合物流企业，分别在青岛、天津、大连、宁波、深圳、广州、厦门等国内主要港口城市设立分公司，以全方位、立体化、多元化的物流平台为客户提供满意的服务。",
      mapText2: "",
      mapText3: "",
      mapText4: "",
      mapText5: "",
      partnerList: {
        pic1: 1,
        pic2: 1,
        pic3: 1,
        pic4: 1,
        pic5: 1,
        pic6: 1,
        pic7: 1,
        pic8: 1,
        pic9: 1,
        pic10: 1,
        pic11: 1
      },
      homeUrl: {
        homeImage: require("../assets/img/map-shanghai.png")
      }
    };
  },

  methods: {
    coord(e) {
      for (var i in this.partnerList) {
        this.partnerList[i] = 1;
      }
      this.mapText2 = "";
      this.mapText3 = "";
      this.mapText4 = "";
      this.mapText5 = "";
      if (e == 1) {
        this.homeUrl.homeImage = require("../assets/img/map-shanghai.png");
        this.mapText =
          "中航运上海是中国区总公司，于2020年3月成立，公司以海、空货运代理业务为主，集海上运输、航空运输、海铁联运、国际多式联运、合同物流、仓储服务等为一体的大型现代化综合物流企业，分别在青岛、天津、大连、宁波、深圳、广州、厦门等国内主要港口城市设立分公司，以全方位、立体化、多元化的物流平台为客户提供满意的服务。";
        this.mapHeadline = "中航运上海";
      } else if (e == 2) {
        this.partnerList.pic6 = 0;
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-dalian.png");
        this.mapText =
          "中航运大连分公司成立于2020年，服务涵盖东北三省， 在主要海、空、陆运网点如满洲里，哈尔滨，长春、沈阳、营口等均有签约合作单位，特色服务范围为汽车物流及零配件配送业务、化工品及危险品运输业务、冷藏箱进出口运输服务、特种箱及滚装船运输服务、设备及大件运输业务、进出口报关、报检业务、仓储及分拨配送服务、铁路多式联运业务和公路运输拖车业务。";
        this.mapHeadline = "中航运大连";
      } else if (e == 3) {
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-tianjin.png");
        this.mapText =
          "中航运天津分公司，以海运整箱进出口为经营核心，立足于港口城市天津，拥有十年以上经验员工若干，服务客户涵盖天津，北京，华北及西部延伸，集货运代理、订舱、运输、堆场、自有箱、码头服务等多种业务为一体的综合性物流企业。";
        this.mapText2 =
          "公司与MSC,HPL,OOCL等各大船公司均保持长期的合作，尤其在美国和加拿大航线上，可根据客户不同需求提供特色SOC服务，在满足更高客户要求的同时协助客户控制成本，并且在天津港北疆和东疆港区均拥有集团下属的自有堆场，可随时操作提箱，装箱，仓储等各项附加业务；另外，公司在华北最大的空运货物集散地北京首都机场及大兴机场拥有强大的操作团队，可为客户提供完整的空运进出口全程方案设计。互信、和谐、包容的合作氛围及有序的管理，实现与客户的合作共赢。";

        this.mapHeadline = "中航运天津";
      } else if (e == 4) {
        this.homeUrl.homeImage = require("../assets/img/map-qingdao.png");
        this.mapText =
          "中航运青岛分公司作为SSL中国区域业务量最大、业务范围最广的分公司，一直承担着重要的推进和支持作用。同时依托总部和集团在全国区域的协调能力和强大的服务平台，以及先进的操作系统和一批从事国际货物运输的高级专业团队，为更多客户提供量身定制的供应链解决方案。";
        this.mapText2 =
          "青岛分公司设有国际海运部、空运部、海外代理部、操作部、客户服务部等，旨在为客户提供更安全、更高效、更系统的综合性物流服务，在青岛口岸及华北区域取得更多的市场份额和更高的知名度。";

        this.mapHeadline = "中航运青岛";
      } else if (e == 5) {
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic10 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-ningbo.png");
        this.mapText =
          "中航运宁波分公司成立于2020年，以海运整箱进出口为核心，多元化经营 ，为客户提供跨境电商拼箱、海运拼箱进出口，多式联运门到门服务，包括报关报检、仓储和国内陆运业务。亚马逊全球FBA头程服务，业务覆盖网络：加拿大、美国、欧洲、澳大利亚及日本；国内辐射地区：宁波、上海、深圳，为跨境电商进口和木材进口提供便捷一条龙的全段供应链管理服务。";
        this.mapHeadline = "中航运宁波";
      } else if (e == 6) {
        this.partnerList.pic6 = 0;
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic10 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-xiamen.png");
        this.mapText =
          "中航运厦门分公司凭借海、空、陆运各方面的优势,提供全方位的专业服 务，包括订舱、收货、发货、代安排各种运输工具到码头或机场，签发空运 与海运提单、代理报关、 代购货物运输保险、到货通知、国外代理清关等 多元灵活的服务。与专业的外贸进出口公司密切合作，可根据客户要求代办进出口代理业务，代办全套出口单证包括商检、产地证等。";
        this.mapText3 =
          "海运服务结合MSC、EMC、OOCL等船公司的优势价格，及其他航线船公司的优惠价格，为客户提供最好的服务。空运为港龙（KA）、国泰（CX）、 菲航（PR）等航空公司的航线。另外，优质的整合铁路运输服务，能提供中欧铁路全线整箱及拼箱进出口运输服务及优惠运价。";
        this.mapHeadline = "中航运厦门";
      } else if (e == 7) {
        this.partnerList.pic6 = 0;
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic10 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-guangzhou.png");
        this.mapText =
          "中航运广州分公司成立于2020年3月，依靠华南地区最大的铁路和公路 内陆中枢位置优势，货物吞吐量占全国前列的广州白云新机场，以及历史悠久的黄埔海港，和发展迅猛的南沙海港，南沙自贸区，南沙综合保税园区，在华南地区，特别以CIF主导的非洲市场，中东和东南亚市场，配合“一带一路”发展方向，提供全面的进出口海运、空运、 集装箱拼装、多式联运、FBA及合同物流等服务。";
        this.mapText3 =
          "范围覆盖广东、广西、云南、四川、贵州、湖南等，并通过中航运在全世界60多国家的服务网点，为国内的生产厂家、物流货代企业和海外买家提供优质的综合物流服务。";
        this.mapText4 = "广州办公室新地址：";
        this.mapText5 = "广州市天河区华穗路406号保利克洛维中景B座 1906单位";
        this.mapHeadline = "中航运广州";
      } else if (e == 8) {
        this.partnerList.pic6 = 0;
        this.partnerList.pic8 = 0;
        this.partnerList.pic9 = 0;
        this.partnerList.pic10 = 0;
        this.partnerList.pic11 = 0;
        this.homeUrl.homeImage = require("../assets/img/map-shenzhen.png");
        this.mapText =
          "中航运深圳分公司成立于2020年3月，依靠集装箱吞吐量排名世界第四的深圳盐田，蛇口、赤湾、大铲湾等海港，盐田综合物流保税园区，以及深圳航空港、香港航空港和广州机场，在华南地区提供全面的进出口海运、空运、集装箱拼装、多式联运、FBA及合同物流等服务。 ";
        this.mapText3 =
          "范围覆盖广东、广西、云南、四川、贵州、湖南等，并通过中航运在全世界60多国家的服务网点，为国内的生产厂家，物流货代企业和海外买家提供优质的综合物流服务。";
        this.mapText4 = "深圳办公室新地址：";
        this.mapText5 =
          "深圳市福田区深南中路与同心路交汇处中信城市广场办公楼12 层1210-2";
        this.mapHeadline = "中航运深圳";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue